import { PageHeader } from '@ant-design/pro-layout';
import { Select, Spin } from 'antd';
import { useDestination } from 'api/destinations.api';
import React from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { DestinationEditor } from '../../components/DestinationEditor';
import DestinationEditorProvider, {
    useDestinationEditor,
} from '../../components/DestinationEditor/DestinationEditorContext';

import styles from './DestinationEditorPage.module.css';

export function DestinationEditorPage() {
    const { id: destinationId } = useParams<{ id: string }>();
    const { destination, isLoading } = useDestination(destinationId || '');

    if (isLoading) {
        return (
            <div className="full-page-content-center column-center">
                <Spin size="large" />
            </div>
        );
    }

    return (
        <DestinationEditorProvider destination={destination}>
            <DestinationEditorPageInner
                destinationId={destinationId || ''}
                isLoading={isLoading}
            />
        </DestinationEditorProvider>
    );
}

type DestinationEditorPageInnerProps = {
    destinationId: string;
    isLoading: boolean;
};

function DestinationEditorPageInner({
    destinationId,
}: DestinationEditorPageInnerProps) {
    const navigate = useNavigate();
    const location = useLocation();
    const { locale, setLocale } = useDestinationEditor();

    const handleBack = () => {
        // Check if we have a returnTo state from the Link navigation
        const returnTo = location.state?.returnTo;

        console.log('returnTo', returnTo);

        if (returnTo) {
            // Navigate to the exact URL with preserved parameters
            navigate(returnTo);
        } else {
            // Fallback to destinations overview
            navigate('/destinations/overview');
        }
    };

    return (
        <div className="full-page">
            <PageHeader
                title={
                    destinationId ? 'Edit destination' : 'Add new destination'
                }
                ghost={false}
                onBack={handleBack}
                extra={
                    <Select
                        className={styles.localeSelector}
                        size="large"
                        value={locale}
                        placeholder="Select a person"
                        onChange={setLocale}
                        options={[
                            {
                                value: 'en',
                                label: '🇬🇧 English',
                            },
                            {
                                value: 'nl',
                                label: '🇳🇱 Dutch',
                            },
                            {
                                value: 'fr',
                                label: '🇫🇷 French',
                            },
                            {
                                value: 'de',
                                label: '🇩🇪 German',
                            },
                            {
                                value: 'pt',
                                label: '🇵🇹 Portuguese',
                            },
                            {
                                value: 'es',
                                label: '🇪🇸 Spanish',
                            },
                        ]}
                    />
                }
            />
            <DestinationEditor />
        </div>
    );
}
